export const EVENT_AUTOCOMPLETE_AFFILIATE = 'ebdssbeac';
